import api from './api';
import { API_ENDPOINTS } from '../constants/config';
import { getApiErrorMessage } from '../utils/errorHandler';

const branchAddressService = {
  // Fetch all active branch addresses
  // Used in Branch Address Manager and site dropdown
  async getAll() {
    try {
      const res = await api.get(API_ENDPOINTS.BRANCH_ADDRESSES);
      return { success: true, data: res.data };
    } catch (error) {
      return {
        success: false,
        error: getApiErrorMessage(error, 'Failed to fetch branch addresses'),
      };
    }
  },

  // Create a new branch address
  async create(name, address) {
    try {
      const res = await api.post(API_ENDPOINTS.BRANCH_ADDRESSES, {
        name,
        address,
      });

      return { success: true, data: res.data };
    } catch (error) {
      return {
        success: false,
        error: getApiErrorMessage(error, 'Failed to create branch address'),
      };
    }
  },

  // Update branch name or address
  async update(id, name, address) {
    try {
      const res = await api.put(API_ENDPOINTS.BRANCH_ADDRESS_DETAILS(id), {
        name,
        address,
      });

      return { success: true, data: res.data };
    } catch (error) {
      return {
        success: false,
        error: getApiErrorMessage(error, 'Failed to update branch address'),
      };
    }
  },

  // Set selected branch as default
  async setDefault(id) {
    try {
      const res = await api.put(API_ENDPOINTS.BRANCH_ADDRESS_SET_DEFAULT(id));
      return { success: true, data: res.data };
    } catch (error) {
      return {
        success: false,
        error: getApiErrorMessage(error, 'Failed to set default branch address'),
      };
    }
  },

  // Soft delete branch address
  async remove(id) {
    try {
      const res = await api.delete(API_ENDPOINTS.BRANCH_ADDRESS_DETAILS(id));
      return { success: true, data: res.data };
    } catch (error) {
      return {
        success: false,
        error: getApiErrorMessage(error, 'Failed to delete branch address'),
      };
    }
  },
};

export default branchAddressService;